import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantInfoService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type SponsorFieldValuesProps = {
	id: string;
	name: string;
	type: string;
};

type SponsorFieldMutationProps = {
	id: number;
	values: SponsorFieldValuesProps;
	onSuccessHandler?: Function;
};

const useSponsorFieldMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, values }: SponsorFieldMutationProps) =>
			merchantInfoService.editSponsorField(id, values.id),
		{
			onSuccess(_data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Field Sponsor has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useSponsorFieldMutation;
